import Http from '@/api/http.js'

export default {
  show(id) {
    return Http.get(`/buildings/${id}`);
  }, 
  index(params){
    return Http.get(`/buildings`, {
      params
    });
  },
  create(building){
    return Http.post(`/buildings`, {building: {...building}})
  },
  update(building){
    return Http.put(`/buildings/${building.id}`, {building: {...building}})
  },

}